import { render, staticRenderFns } from "./similars-slider.vue?vue&type=template&id=4cca40d8&"
import script from "./similars-slider.vue?vue&type=script&lang=js&"
export * from "./similars-slider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports